export const APTOS_PAGAMENTOS = 'APTOS_PAGAMENTOS';
export const APTOS_PAGAMENTOS_START = 'APTOS_PAGAMENTOS_START';
export const APTOS_PAGAMENTOS_SUCCESS = 'APTOS_PAGAMENTOS_SUCCESS';
export const APTOS_PAGAMENTOS_ERROR = 'APTOS_PAGAMENTOS_ERROR';

export const APTOS_PAGAMENTOS_TOTAL = 'APTOS_PAGAMENTOS_TOTAL';
export const APTOS_PAGAMENTOS_TOTAL_START = 'APTOS_PAGAMENTOS_TOTAL_START';
export const APTOS_PAGAMENTOS_TOTAL_SUCCESS = 'APTOS_PAGAMENTOS_TOTAL_SUCCESS';
export const APTOS_PAGAMENTOS_TOTAL_ERROR = 'APTOS_PAGAMENTOS_TOTAL_ERROR';
